<template>
  <!-- 검색 결과 없을 경우 -->
  <div class="text-center no-result mt-7">
    <img src="@/assets/images/common/warning.png" alt="!" class="mb-2">

    <!-- 데이터가 없을 경우 -->
    <p v-if="searchText === ''">
      데이터가 없습니다.
    </p>
    <!-- 검색결과 없을 경우 -->
    <p v-else>
      검색결과가 없습니다. <br>
      다시 검색해주시기 바랍니다.
    </p>

  </div>
</template>

<script>
export default {
  name: 'NewsEmptyList',
  props: {
    searchText: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.srch-wrap {
  &-box {
    width: 40rem;
    float: right;
  }
  &::after {
    @include clear-float;
  }
}
</style>
